import { useMemo } from 'react';

import { skipToken } from '@reduxjs/toolkit/query';

import { useRetailerSettings } from '../useRetailerSettings';

import { useFetchCustomerSuppliedSinksQuery } from '~/api/easy-estimator-api/sinks-api/sinksService';
import { useSelectedStore } from '~/api/easy-estimator-api/stores-api/useSelectedStore';
import { useStores } from '~/api/easy-estimator-api/stores-api/useStores';
import { SINK_OPTIONS } from '~/core/enums';
import { ApplianceSource, ApplianceType } from '~/core/models';
import { emptyArray, makeSinksSelector } from '~/core/utils';
import { useAppSelector } from '~/redux/hooks';
import { selectSelectedColor } from '~/redux/slices/color';
import { selectSelectedBrowsingOption } from '~/redux/slices/sink';
import { selectZipcode } from '~/redux/slices/zipcode';

export const useFetchCustomerSuppliedSinks = () => {
  const selectedColor = useAppSelector(selectSelectedColor);
  const selectedOption = useAppSelector(selectSelectedBrowsingOption);
  const zipcode = useAppSelector(selectZipcode);

  const { stores } = useStores();
  const { retailerSettings } = useRetailerSettings();
  const selectedStore = useSelectedStore();

  const selectSinksCustomerSuppliedTransformed = useMemo(
    () => makeSinksSelector(),
    []
  );

  const {
    customerSuppliedSinks,
    isFetching: isFetchingCustomerSuppliedSinks,
    isError: isErrorCustomerSuppliedSinks,
  } = useFetchCustomerSuppliedSinksQuery(
    !zipcode ||
      !selectedColor ||
      !stores.length ||
      selectedOption !== SINK_OPTIONS.SUPPLY_SINKS
      ? skipToken
      : {
          params: {
            zipCode: zipcode,
            storeId: retailerSettings?.showStores
              ? selectedStore?.companyId
              : undefined,
            ...(selectedColor?.qteGrpID
              ? { prodQteGrpID: selectedColor.qteGrpID }
              : {}),
          },
        },
    {
      selectFromResult: ({ data, ...rest }) => ({
        customerSuppliedSinks: selectSinksCustomerSuppliedTransformed(
          data ?? emptyArray,
          ApplianceSource.PROGRAM,
          ApplianceType.SINK_LABOR
        ),
        ...rest,
      }),
    }
  );

  return {
    customerSuppliedSinks,
    isFetchingCustomerSuppliedSinks,
    isErrorCustomerSuppliedSinks,
  };
};
